export default interface ICompAddress {
    address1: string;
    address2?: string;
    unitNumber?: string;
    city?: string;
    state?: string;
    zipCode?: string;
}

export function newCompAddress(): ICompAddress {
    const result: ICompAddress = {
        address1: ''
    };
    return result;
}
